import FormElementInterface from "types/FormElementInterface";
import Error from "components/Forms/Error";
import Label from "components/Forms/Label";
import { useFormContext } from "react-hook-form";
import css from './style.module.scss';
import { useEffect } from "react";

export interface OptionInterface {
    id: string,
    value: string
}

interface Props extends FormElementInterface {
    options: Array<OptionInterface>,
    disabled?: boolean,
    className?: string
}

const Select = (props: Props) => {
    const { register, unregister, setValue } = useFormContext();

    useEffect(() => {
        return () => {
            unregister(props.name)
        }
    }, []);

    const onKeyPress = (e: React.KeyboardEvent<HTMLSelectElement>) => {
        // If arrow down select next. If arrow up select previous.
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            const select = e.target as HTMLSelectElement;
            const currentIndex = select.selectedIndex;
            const nextIndex = e.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
            const nextOption = select.options[nextIndex];
            if (nextOption) {
                nextOption.selected = true;
                setValue(props.name, nextOption.value);
            }
        }
    }

    const arrowValue = (index: number) => {
        const select = document.querySelector(`select[name="${props.name}"]`) as HTMLSelectElement;
        const currentIndex = select.selectedIndex;
        const nextIndex = currentIndex + index;
        const nextOption = select.options[nextIndex];
        if (nextOption) {
            nextOption.selected = true;
            setValue(props.name, nextOption.value);
        }
    }

    return (
        <div className={`w-full ${props.disabled ? 'cursor-not-allowed' : ''} ${props.className || ''}`}>
            <div className='flex items-center justify-between gap-2'>
                <Label name={props.name} label={props.label} />
                <div className='flex gap-2 -mt-1 mr-2'>
                    <button type="button" onClick={() => arrowValue(-1)}>&larr;</button>
                    <button type="button" onClick={() => arrowValue(1)}>&rarr;</button>
                </div>
            </div>
            <select
                onKeyDown={onKeyPress}
                className={`border p-2 h-10 w-full rounded ${props.disabled ? css.disabled : ''}`}
                {...register(props.name)}
                >
                {
                    props.placeholder &&
                    <option value=''>{props.placeholder}</option>
                }

                {
                    props.options.map((opt, index) => (
                        <option key={index} value={opt.id}>
                            {opt.value}
                        </option>
                    ))
                }
            </select>
            <Error name={props.name} />
        </div>
    )
}

export default Select;